import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

const ModalStatusUpdate = () => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.updateStatus');
  const onClose = () => {
    closeSingleModal('updateStatus');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Atualizar status"
      height={'auto'}
      width={'60vw'}
    >
      <Form.Validity.Status.Update />
    </Modal>
  );
};

export default ModalStatusUpdate;
